export const authRole = {
  SuperAdmin: [
    'SUPER_ADMIN',
    'COMPANY_ADMIN',
    'DEPARTMENT_ADMIN',
    'ZONE_ADMIN',
  ],
  CompanyAdmin: ['COMPANY_ADMIN', 'DEPARTMENT_ADMIN', 'ZONE_ADMIN'],
  DepartmentAdmin: ['DEPARTMENT_ADMIN'],
  ZoneAdmin: ['ZONE_ADMIN'],  
};

export const defaultUser = {
  displayName: 'John Alex',
  email: 'demo@example.com',
  token: 'access-token',
  role: 'user',
  photoURL: '/assets/images/avatar/A11.jpg',
};
export const allowMultiLanguage = import.meta.env.VITE__MULTILINGUAL === 'true';
export const fileStackKey = import.meta.env.VITE__FILESTACK_KEY;
export const initialUrl = import.meta.env.VITE__INITIAL_URL;

export const apiUrl =
  process.env.REACT_APP_ENVIRONMENT === 'prod'
    ? process.env.REACT_APP_API_URL_PROD
    : process.env.REACT_APP_API_URL_DEV;
export const openRouteServiceKey = process.env.OPEN_STREET_ROUTE_SERVICE_KEY;
export const apiEndpoints = {
  service: 'service',
};
